import {ViewType} from "../../../gd/const/views/view-type"
import ProjectViews from "../project-views"
import {ViewTypeConfigs} from "../../../gd/const/views/view-type-config"
import ProjectViewFactory from "../factory"
import {projectViews_createProjectViewFromConfig} from "../actions/create"
import RequestForm from "../../form/request-form"
import ProjectView from "../project-view";

// const debug = "projectViews_normalize"
const debug = false

export default function projectViews_normalize(projectViews: ProjectViews) {
    // if expenses enabled and no PROJECT_EXPENSES view then add it
    /*const expensesView = projectViews.getBySystemType(ViewType.PROJECT_EXPENSES)[0]
    if (projectViews.project.properties.expenses && !expensesView) {
        projectViews.createView({
            name        : ViewTypeConfigs[ViewType.PROJECT_EXPENSES]?.name,
            systemType  : ViewType.PROJECT_EXPENSES,
            isPinned    : true
        })
    }*/

    // add link view for link projects (is required for URL edit)
    if (projectViews.project.isLink) {
        projectViews.add(ProjectViewFactory({
            name        : ViewTypeConfigs[ViewType.PROJECT_LINK]?.name,
            systemType  : ViewType.PROJECT_LINK,
            isPinned    : true
        }, projectViews))
        projectViews.sort()
    }

    /** --- ADD MISSING FORM VIEWS [Start] --- **/
    const newViews: ProjectView[] = []
    _.map(projectViews.project.properties.forms, form=>{
        if (!projectViews.getFormView(form.id)) {
            const requestForm = new RequestForm(form)
            const newView = projectViews_createProjectViewFromConfig(projectViews, requestForm.projectViewConfig)

            debug && console.log(debug, 'newView', newView, requestForm)

            newViews.push(newView)
        }
    })

    if (!_.isEmpty(newViews)) {
        _.map(newViews, newView => {
            projectViews.add(newView)
        })

        projectViews.sort()
        projectViews.save()
    }
    /** --- ADD MISSING FORM VIEWS [End] --- **/
}